import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { AppService } from 'src/@core/services/app.service';
import { JobService } from 'src/@core/services/job/job.service';
import { NotificationService } from 'src/@core/services/notification.service';
import { environment } from 'src/environments/environment';
import { PDFDocument } from 'pdf-lib';
import { AgreementDocComponent } from '../agreement-doc/agreement-doc.component';
import { ProcessAttendancePictureChunk, UploadAttendancePictureChunk } from 'src/@core/services/util/api.endpoints';
import { roles } from 'src/app/shared/helpers/roles-permissions';
import { Location } from '@angular/common';
export class contractMetaDataData {
  agreementDate: any;
  enterpriseName: string = "";
  enterpriseAddress: string = "";
  companyName: any;
  companyAdrress: any;
  commencementDate: any;
  flatAmount: any;
  advanceAmount: any;
  contractorCompanyName: any;
  agencySignatureUploadedDate: any;
  contractorName: any;
  agencySignature: any;
  clientName: any;
  enterpriseSignatureDate: any;
  enterpriseSignature: any;
  invoiceDate: any
}
@Component({
  selector: 'hour4u-admin-signed-document',
  templateUrl: './signed-document.component.html',
  styleUrls: ['./signed-document.component.scss']
})
export class SignedDocumentComponent implements OnInit {
  @ViewChild(AgreementDocComponent, { static: false }) agreementDoc: AgreementDocComponent;
  @ViewChild(AgreementDocComponent, { static: false }) agreementDoc1: AgreementDocComponent;
  enabledBtn: boolean = false;
  selectedSignatureImg: any = null;
  selectedPojectData: any = null;
  profile = this.appService.getCurrentAccount();
  isLoading: boolean = false;
  documentUrl: any = "";
  step: number = 1;
  showFullDocument: boolean = false;
  isDownloading: boolean = false;
  @ViewChild('content', { static: false }) content: ElementRef;
  diameter = 30;
  loaderColor: string;
  mode = 'indeterminate';
  contractMetaData: contractMetaDataData = new contractMetaDataData();
  selectedDocument: any = null;
  jobId: any = null;
  isViewOnly: boolean = false;
  selectedQuote: any = null;
  roles = roles;

  constructor(
    private appService: AppService,
    private jobService: JobService,
    private notify: NotificationService,
    private route: ActivatedRoute,
    private router: Router,
    private cdRef: ChangeDetectorRef,
    private location: Location
  ) { }

  ngOnInit() {
    this.selectedPojectData = JSON.parse(localStorage.getItem("selectedPojectData"));
    this.isLoading = true;
    if (!this.selectedPojectData) {
      this.isLoading = false;
      this.goToBackPage();
    }

    if (this.selectedPojectData && !this.selectedPojectData.id) {
      this.contractMetaData.enterpriseName = this.selectedPojectData.employerName;
      this.isLoading = false;
    }

    if (this.selectedPojectData && this.selectedPojectData.selectedQuote) {
      this.isLoading = false;
      this.selectedQuote = this.selectedPojectData.selectedQuote;
      this.jobId = this.selectedPojectData.id;
      this.isViewOnly = true;
      if (this.selectedPojectData.selectedQuote.contractMetaData) {
        this.contractMetaData = this.selectedPojectData.selectedQuote.contractMetaData;
      }
    }
  }

  enabledSignedContractBtn(event: any) {
    this.enabledBtn = false;
    this.step = event.step;
    this.selectedSignatureImg = event.selectedSignatureImg;
    this.agreementDoc.refresh(this.selectedSignatureImg); // Adjust 'refresh' to the actual method name
    // this.agreementDoc1.refresh(this.selectedSignatureImg); // Adjust 'refresh' to the actual method name
    if (event.check) {
      this.enabledBtn = true;
      this.cdRef.detectChanges();
    } else {
      // this.notify.showMessage("Please accept terms and condition!", 3000);
    }
  }

  shareSignedDocument() {
    alert("Coming soon...")
  }

  // downloadSignedDoc() {
  //   this.fetchSigedDocument();
  // }

  signContract() {
    this.isLoading = true;
    if (this.selectedSignatureImg) {
      if (this.selectedPojectData && this.selectedPojectData.selectedQuote && this.selectedPojectData.selectedQuote.quoteStatusChangeCalled) {
        // attach signature for quote approval time (Enterprise signature)
        // if (this.step == 1) {
        this.jobService.uploadSignatureImages(this.selectedSignatureImg).subscribe(res => {
          this.selectedPojectData.selectedProject.enterpriseSignature = environment.image_url + res.key;
          // this.updateQuotation();
          this.getBase64PDF();
          return;
        }, (err => {
          this.isLoading = false;
        }))
        // }
        // if (this.step == 2) {
        //   this.getBase64PDF();
        // }
      } else {
        // attach signature for project create time (Agency signature)
        if (this.selectedPojectData) {
          this.jobService.uploadSignatureImages(this.selectedSignatureImg).subscribe(res => {
            this.selectedPojectData.agencySignature = environment.image_url + res.key;
            const dateString = new Date();
            const dateObj = new Date(dateString);
            const year = dateObj.getFullYear();
            const month = dateObj.getMonth() + 1;
            const day = dateObj.getDate();
            const resultArray: number[] = [year, month, day];
            this.selectedPojectData.agencySignatureUploadedDate = resultArray;
            this.saveProject();
          }, (err => {
            this.isLoading = false;
          }))
        } else {
          this.isLoading = false;
          this.goToBackPage();
        }
      }
    } else {
      this.isLoading = false;
      this.notify.showMessage("Please do signature!", 3000);
    }
  }

  updateQuotation(status?: string) {
    const dateString = this.selectedPojectData.selectedQuote.quoteConditions.quoteValidity;
    const dateObj = new Date(dateString);
    const year = dateObj.getFullYear();
    const month = dateObj.getMonth() + 1;
    const day = dateObj.getDate();
    this.isLoading = true;
    const resultArray: number[] = [year, month, day];

    const dateString1 = new Date();
    const dateObj1 = new Date(dateString1);
    const year1 = dateObj1.getFullYear();
    const month1 = dateObj1.getMonth() + 1;
    const day1 = dateObj1.getDate();
    this.isLoading = true;
    const resultArray1: number[] = [year1, month1, day1];

    if (!this.contractMetaData.enterpriseSignatureDate) {
      this.contractMetaData.enterpriseSignatureDate = resultArray1;
    }
    if (!this.contractMetaData.enterpriseSignature) {
      this.contractMetaData.enterpriseSignature = this.selectedPojectData.selectedProject.enterpriseSignature;
    }

    let obj = {
      "id": this.selectedPojectData.selectedQuote.id,
      "entityId": this.profile.entity.id,
      "jobId": this.selectedPojectData.selectedProject.id,
      "assignmentId": this.selectedPojectData.selectedProject.assignmentId,
      "status": status ? status : this.selectedPojectData.selectedQuote.status,
      "jobRateCards": this.selectedPojectData.selectedQuote.jobRateCards,
      "variableJobRateCards": this.selectedPojectData.selectedQuote.variableJobRateCards,
      "quoteConditions": {
        "expiryDate": this.selectedPojectData.selectedQuote.quoteConditions.expiryDate,
        "quoteValidity": resultArray,
        "paymentTerms": this.selectedPojectData.selectedQuote.quoteConditions.paymentTerms,
        "addtional": this.selectedPojectData.selectedQuote.quoteConditions.additionalTermsAndConditions
      },
      "attachments": this.selectedPojectData.selectedQuote.attachments,
      "enterpriseSignature": this.selectedPojectData.selectedProject.enterpriseSignature,
      "agencySignature": this.selectedPojectData.selectedQuote.agencySignature,
      "enterpriseSignatureDate": resultArray1,
      "contractMetaData": this.contractMetaData
    }
    this.jobService.updateQuotation(obj).subscribe(res => {
      if (res) {
        // this.notify.showMessage('Quotation update successfully!', 2000);
        // if (this.step == 1) {
        //   setTimeout(() => {
        //     this.isLoading = false;
        //     this.step = this.step + 1;
        //     this.showFullDocument = true;
        //     this.fetchSigedDocument();
        //   }, 100);
        // }
        // if (this.step == 2) {
        this.isLoading = false;
        this.notify.showMessage('Signed document successfully!', 2000);
        localStorage.removeItem("selectedPojectData");
        this.router.navigateByUrl('/job/view/' + this.selectedPojectData.id + '/' + 'Quotes');
        // this.dialogRef.close(true);
        // }
      }
    }, (err => {
      console.log(err)
      this.isLoading = false;
    }))
  }

  saveProject() {
    this.isLoading = true;
    if (!this.contractMetaData.agencySignature) {
      this.contractMetaData.agencySignature = this.selectedPojectData.agencySignature;
    }
    if (!this.contractMetaData.agencySignatureUploadedDate) {
      this.contractMetaData.agencySignatureUploadedDate = this.selectedPojectData.agencySignatureUploadedDate;
    }
    if (!this.contractMetaData.flatAmount) {
      this.contractMetaData.flatAmount = this.getFinalTotalAmount() * 1.18;
    }
    this.selectedPojectData.contractMetaData = this.contractMetaData;
    if (this.selectedPojectData.id) {
      // Update existing project
      this.jobService.update(this.selectedPojectData.id, this.selectedPojectData).subscribe(
        (data) => {
          this.isLoading = false;
          this.notify.showMessage("Project updated successfully!", 2000);
          this.goToSuccessPage();
          // this.showFullDocument = true;
        },
        (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.notify.showMessage("Error while updating project!", 2000);
        }
      );
    } else {
      // Create new project
      this.jobService.create(this.selectedPojectData).subscribe(
        (data) => {
          this.selectedPojectData = data;
          this.isLoading = false;
          this.notify.showMessage("Project created successfully!", 2000);
          this.goToSuccessPage();
          // this.showFullDocument = true;
          // this.uploadSignedDocument();
        },
        (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.notify.showMessage("Error while creating project!", 2000);
        }
      );
    }
  }

  getFinalTotalAmount() {
    let amount = 0;
    if (this.selectedPojectData && this.selectedPojectData.billingType && this.selectedPojectData.billingType.includes('FIXED')) {
      if (this.selectedPojectData && this.selectedPojectData.jobRateCards && this.selectedPojectData.jobRateCards.length) {
        this.selectedPojectData.jobRateCards.forEach(element => {
          amount = amount + (element.totalAmount);
        });
      }
    }
    return amount;
  }

  uploadSignedDocument() {
    this.isLoading = true;
    if (this.selectedPojectData.selectedProject.documentUrl) {
      let obj = {
        "issuerEntityId": this.selectedPojectData.selectedQuote.agencyDetails.id,
        "subjectEntityId": this.selectedPojectData.selectedQuote.enterpriseDetails.id,
        "documentUrl": this.selectedPojectData.selectedProject.documentUrl,
      }
      this.jobService.uploadSignedContract(obj).subscribe((res) => {
        this.isLoading = false;
        this.updateQuotation("ACCEPTED");
      }, (err => {
        console.log(err)
        this.isLoading = false;
        this.notify.showMessage("Something went wrong!", 2000);
      }))
    } else {
      this.isLoading = false;
      this.notify.showMessage("Signed document not generated yet!", 2000);
    }
  }

  fetchSigedDocument() {
    this.isLoading = true;
    this.jobService.fetchSignedDocument(this.selectedPojectData.selectedQuote.id).subscribe(res => {
      this.isLoading = false;
      if (res && res.key) {
        this.documentUrl = res.key;
      }
    }, (err => {
      console.log(err)
      this.isLoading = false;
      this.notify.showMessage("Signed document not generated!", 2000);
    }))
  }

  // async getBase64PDF() {
  // const pdfStyles = `
  // .contract-wrapper {
  //     padding: 24px;
  //     background: #fff;
  //     border-radius: var(--radius-xl, 12px);
  // }

  // .header {
  //     border-radius: var(--radius-xl, 12px);
  //     background: var(--Neutral-20, #F6F6F6);
  //     padding: 12px 16px;
  // }

  // .sub-header {
  //     padding: 12px 16px;
  // }

  // .f-wrap {
  //     flex-wrap: wrap !important;
  // }

  // .signature-section {
  //     width: 50%;
  // }

  // .inputt-wrap {
  //     border: none;
  //     border-bottom: 1px solid #000;
  //     outline: none;
  // }

  // .signature-img {
  //     max-width: 60%;
  //     max-height: 20vh;
  // }

  // .custom-signature-card {
  //     border-radius: var(--radius-xl, 12px);
  //     border: 1px dashed var(--Neutral-60, #1A1A1A);
  //     background: var(--base-w-white, #FFF);
  //     box-shadow: 0px 1px 2px 0px rgba(26, 26, 26, 0.04);
  //     display: inline-flex;
  //     height: 132px;
  //     padding: 16px 20px;
  //     flex-direction: column;
  //     justify-content: center;
  //     align-items: center;
  //     gap: 12px;
  // }

  // .d-flex {
  //     display: flex;
  // }

  // .secondary {
  //     color: #1A1A1A !important;
  // }

  // .sub-heading-mm {
  //     font-style: normal !important;
  //     font-size: 14px !important;
  // }

  // .sub-heading-sm {
  //   font-style: normal !important;
  //     font-size: 14px !important;
  // }

  // .justify-space-between {
  //     justify-content: space-between !important;
  // }

  // .text-center {
  //     text-align: center;
  // }

  //  .outer-wrap {
  //     flex: 1;
  //     overflow: visible !important;
  // }

  // .inner-wrap {
  //     flex: 1;
  //     overflow-y: visible !important;
  // }
  //      .w-70 {
  //   width : 100% !important;
  // }

  // .h-82{
  // height : auto !important;
  // }
  // // .mt-6{
  // // margin-top : 0px !important;
  // // }
  // `;

  // const element = this.content.nativeElement;
  // element.style.display = 'block';

  // const originalHeight = element.style.height;
  // const originalOverflow = element.style.overflow;
  // this.isLoading = true;

  // const styleElement = document.createElement('style');
  // styleElement.type = 'text/css';
  // styleElement.innerHTML = pdfStyles;
  // document.head.appendChild(styleElement);

  // // Function to resize inputs if necessary
  // const resizeInputs = () => {
  //   const inputs = element.querySelectorAll('.inputt-wrap');
  //   inputs.forEach(input => {
  //     const valueLength = input.value.length;
  //     const newWidth = valueLength && (valueLength >= 20 && valueLength <= 40) ? (valueLength + 1) * 8 : 150;
  //     input.style.width = `${newWidth}px`;
  //   });
  // };

  // // Load images function
  // const loadImages = (): Promise<void[]> => {
  //   const images = Array.from(document.querySelectorAll('img.signature-img'));
  //   const imagePromises = images.map((img: HTMLImageElement) => {
  //     return new Promise<void>((resolve, reject) => {
  //       fetch(img.src, {
  //         method: 'GET',
  //         mode: 'no-cors'
  //       })
  //         .then(response => {
  //           console.log(response)
  //           resolve();
  //           // if (!response.ok) {
  //           //   throw new Error('Network response was not ok.');
  //           // }
  //           // return response.blob();
  //         })
  //         // .then(blob => {
  //         //   console.log(blob)
  //         //   const objectURL = URL.createObjectURL(blob);
  //         //   img.src = objectURL;
  //         //   resolve();
  //         // })
  //         .catch(error => {
  //           console.error('There has been a problem with your fetch operation:', error);
  //           reject(new Error('Image failed to load'));
  //         });
  //     });
  //   });
  //   return Promise.all(imagePromises);
  // };


  // // Load fonts function
  // // const loadFonts = () => {
  // //   return new Promise((resolve: any, reject) => {
  // //     document.fonts.ready.then(() => {
  // //       resolve();
  // //     }).catch(reject);
  // //   });
  // // };

  // try {
  //   // Ensure all images and fonts are loaded
  //   await Promise.all([loadImages(), resizeInputs()]);
  //   await new Promise(resolve => setTimeout(resolve, 2000));

  //   // Use html2canvas to capture the entire content as a single canvas
  //   const canvas = await html2canvas(element, {
  //     scale: 2, // Adjust scale if needed
  //     useCORS: true,
  //     allowTaint: true, // Allow taint to render images from other domains
  //   });

  //   // Calculate dimensions for jsPDF
  //   const pdfWidth = canvas.width * 0.264583; // Convert px to mm (1px = 0.264583mm)
  //   const pdfHeight = canvas.height * 0.264583; // Convert px to mm

  //   // Create jsPDF instance
  //   const pdf = new jsPDF('p', 'mm', [pdfWidth, pdfHeight], true);

  //   // Add the captured canvas as an image to jsPDF
  //   pdf.addImage(canvas, 'JPEG', 0, 0, pdfWidth, pdfHeight);

  //   // Generate Base64 representation of the PDF
  //   let pdfBase64 = pdf.output('datauristring');
  //   this.selectedDocument = pdfBase64;

  //   // Convert Base64 to Blob
  //   const base64ToBlob = (base64: string, contentType: string = '', sliceSize: number = 512) => {
  //     const byteCharacters = atob(base64.split(',')[1]);
  //     const byteArrays = [];

  //     for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
  //       const slice = byteCharacters.slice(offset, offset + sliceSize);
  //       const byteNumbers = new Array(slice.length);
  //       for (let i = 0; i < slice.length; i++) {
  //         byteNumbers[i] = slice.charCodeAt(i);
  //       }
  //       const byteArray = new Uint8Array(byteNumbers);
  //       byteArrays.push(byteArray);
  //     }

  //     return new Blob(byteArrays, { type: contentType });
  //   };


  //   //  Convert the Base64 string to a Blob and then to a File object
  //   let pdfBlob = base64ToBlob(pdfBase64, 'application/pdf');
  //   let pdfFile = new File([pdfBlob], 'signed_contract.pdf', { type: 'application/pdf' });

  //   // Check the file size and compress if it's larger than 1 MB
  //   if (pdfFile.size > 1048576) {
  //     console.warn('The generated PDF is larger than 1 MB, compressing...');

  //     // Use pdf-lib to compress the PDF
  //     const compressPDF = async (blob: Blob): Promise<Blob> => {
  //       const arrayBuffer = await (blob as any).arrayBuffer();
  //       const pdfDoc = await PDFDocument.load(arrayBuffer);
  //       const { width, height } = pdfDoc.getPage(0).getSize();

  //       // Create a new PDF and add the compressed pages
  //       const newPdfDoc = await PDFDocument.create();
  //       const pages = await newPdfDoc.copyPages(pdfDoc, pdfDoc.getPageIndices());
  //       pages.forEach(page => newPdfDoc.addPage(page));

  //       // Compress images and fonts
  //       const pdfBytes = await newPdfDoc.save({ useObjectStreams: false });

  //       return new Blob([pdfBytes], { type: 'application/pdf' });
  //     };

  //     pdfBlob = await compressPDF(pdfBlob);
  //     pdfFile = new File([pdfBlob], 'signed_contract_compressed.pdf', { type: 'application/pdf' });
  //   }
  //   console.log(pdfFile)
  //   this.selectedDocument = pdfFile;
  //   this.storePDFInS3(pdfBlob);
  //   // Save or download the PDF
  //   // pdf.save('signed_contract.pdf');

  //   // Reset styles and flags
  //   element.style.height = originalHeight;
  //   element.style.overflow = originalOverflow;
  //   document.head.removeChild(styleElement);
  //   element.style.display = 'none';

  // } catch (error) {
  //   console.error('Error generating PDF:', error);
  //   element.style.height = originalHeight;
  //   element.style.overflow = originalOverflow;
  //   element.style.display = 'none';
  // }

  // }

  async getBase64PDF() {
    let pdfStyles = `
    .contract-wrapper {
        padding: 24px;
        background: #fff;
        border-radius: var(--radius-xl, 12px);
    }

    .header {
        border-radius: var(--radius-xl, 12px);
        background: var(--Neutral-20, #F6F6F6);
        padding: 12px 16px;
    }

    .sub-header {
        padding: 12px 16px;
    }

    .f-wrap {
        flex-wrap: wrap !important;
    }

    .signature-section {
        width: 50%;
    }

    .inputt-wrap {
        border: none;
        border-bottom: 1px solid #000;
        outline: none;
    }

    .signature-img {
        max-width: 60%;
        max-height: 20vh;
    }

    .custom-signature-card {
        border-radius: var(--radius-xl, 12px);
        border: 1px dashed var(--Neutral-60, #1A1A1A);
        background: var(--base-w-white, #FFF);
        box-shadow: 0px 1px 2px 0px rgba(26, 26, 26, 0.04);
        display: inline-flex;
        height: 132px;
        padding: 16px 20px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 12px;
    }

    .d-flex {
        display: flex;
    }

    .secondary {
        color: #1A1A1A !important;
    }

    .sub-heading-mm {
        font-style: normal !important;
        font-size: 14px !important;
    }

    .sub-heading-sm {
      font-style: normal !important;
        font-size: 14px !important;
    }

    .justify-space-between {
        justify-content: space-between !important;
    }

    .text-center {
        text-align: center;
    }

     .outer-wrap {
        flex: 1;
        overflow: visible !important;
    }

    .inner-wrap {
        flex: 1;
        overflow-y: visible !important;
    }
         .w-70 {
      width : 100% !important;
    }

    .h-82{
    height : auto !important;
    }
    `;
    if (window.innerWidth <= 768) {
      pdfStyles = `
    .contract-wrapper {
        padding: 24px;
        background: #fff;
        border-radius: var(--radius-xl, 12px);
    }

    .header {
        border-radius: var(--radius-xl, 12px);
        background: var(--Neutral-20, #F6F6F6);
        padding: 12px 16px;
    }

    .sub-header {
        padding: 12px 11px;
    }

    .f-wrap {
        flex-wrap: wrap !important;
    }

    .signature-section {
        width: 50%;
    }

    .inputt-wrap {
        border: none;
        border-bottom: 1px solid #000;
        outline: none;
    }

    .signature-img {
        max-width: 60%;
        max-height: 20vh;
    }

    .custom-signature-card {
        border-radius: var(--radius-xl, 12px);
        border: 1px dashed var(--Neutral-60, #1A1A1A);
        background: var(--base-w-white, #FFF);
        box-shadow: 0px 1px 2px 0px rgba(26, 26, 26, 0.04);
        display: inline-flex;
        height: 132px;
        padding: 16px 20px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 12px;
    }

    .d-flex {
        display: flex;
    }

    .secondary {
        color: #1A1A1A !important;
    }

    .sub-heading-mm {
        font-style: normal !important;
        font-size: 12px !important;
    }

    .sub-heading-sm {
      font-style: normal !important;
        font-size: 12px !important;
    }

    .justify-space-between {
        justify-content: space-between !important;
    }

    .text-center {
        text-align: center;
    }

     .outer-wrap {
        flex: 1;
        overflow: visible !important;
    }

    .inner-wrap {
        flex: 1;
        overflow-y: visible !important;
    }

    .m-4 {
        margin: 0px !important;
    }

    .w-70 {
        grid-area: agreement-doc;
        //     display: none;
        width: 100% !important;
        padding: 0px !important;
    }

    .w-30 {
        width: 100% !important;
        grid-area: sign-contract;
        padding: 16px !important;
        background-color: transparent !important;
    }

    .h-82 {
        display: grid !important;
        grid-template-areas:
            "sign-contract"
            "agreement-doc" !important;
        height: auto !important;
    }

    .footer-card {
        bottom: 8% !important;
        margin: 0px !important;
    }
    `;
    }

    const element = this.content.nativeElement;
    element.style.display = 'block';

    const originalHeight = element.style.height;
    const originalOverflow = element.style.overflow;
    this.isLoading = true;

    const styleElement = document.createElement('style');
    styleElement.type = 'text/css';
    styleElement.innerHTML = pdfStyles;
    document.head.appendChild(styleElement);

    // Function to resize inputs if necessary
    const resizeInputs = () => {
      const inputs = element.querySelectorAll('.inputt-wrap');
      inputs.forEach(input => {
        const valueLength = input.value.length;
        const newWidth = valueLength && (valueLength >= 20 && valueLength <= 40) ? (valueLength + 1) * 8 : 150;
        input.style.width = `${newWidth}px`;
        if (window.innerWidth <= 768) {
          input.style.lineHeight = '20px';
        }
        input.style.backgroundColor = 'transparent';
      });
    };

    // Load images function
    const loadImages = (): Promise<void[]> => {
      const images = Array.from(document.querySelectorAll('img.signature-img'));
      const imagePromises = images.map((img: HTMLImageElement) => {
        return new Promise<void>((resolve, reject) => {
          fetch(img.src, {
            method: 'GET',
            mode: 'no-cors'
          })
            .then(response => {
              console.log(response)
              resolve();
            })
            .catch(error => {
              console.error('There has been a problem with your fetch operation:', error);
              reject(new Error('Image failed to load'));
            });
        });
      });
      return Promise.all(imagePromises);
    };

    try {
      // Ensure all images and fonts are loaded
      await Promise.all([loadImages(), resizeInputs()]);
      await new Promise(resolve => setTimeout(resolve, 2000));

      // Use html2canvas to capture the entire content as a single canvas
      const canvas = await html2canvas(element, {
        scale: 2, // Adjust scale if needed
        useCORS: true,
        allowTaint: true, // Allow taint to render images from other domains
        scrollX: -window.scrollX,
        scrollY: -window.scrollY,
      });

      console.log(canvas.width, canvas.height)
      // canvas.height = canvas.height + 5000;
      // Calculate dimensions for jsPDF
      const pdfWidth = canvas.width * 0.264583; // Convert px to mm (1px = 0.264583mm)
      const pdfHeight = canvas.height * 0.264583; // Convert px to mm
      console.log(pdfWidth, pdfHeight)
      // Create jsPDF instance
      const pdf = new jsPDF('p', 'mm', [pdfWidth, pdfHeight], true);

      // Add the captured canvas as an image to jsPDF
      pdf.addImage(canvas, 'JPEG', 0, 0, pdfWidth, pdfHeight);

      // Generate Base64 representation of the PDF
      let pdfBase64 = pdf.output('datauristring');
      this.selectedDocument = pdfBase64;

      // Convert Base64 to Blob
      const base64ToBlob = (base64: string, contentType: string = '', sliceSize: number = 512) => {
        const byteCharacters = atob(base64.split(',')[1]);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          const slice = byteCharacters.slice(offset, offset + sliceSize);
          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }

        return new Blob(byteArrays, { type: contentType });
      };


      //  Convert the Base64 string to a Blob and then to a File object
      let pdfBlob = base64ToBlob(pdfBase64, 'application/pdf');
      let pdfFile = new File([pdfBlob], 'signed_contract.pdf', { type: 'application/pdf' });

      console.log(pdfFile.size)

      // Check the file size and compress if it's larger than 1 MB
      if (pdfFile.size > 1048576) {
        console.warn('The generated PDF is larger than 1 MB, compressing...');

        // Use pdf-lib to compress the PDF
        const compressPDF = async (blob: Blob): Promise<Blob> => {
          const arrayBuffer = await (blob as any).arrayBuffer();
          const pdfDoc = await PDFDocument.load(arrayBuffer);
          const { width, height } = pdfDoc.getPage(0).getSize();

          // Create a new PDF and add the compressed pages
          const newPdfDoc = await PDFDocument.create();
          const pages = await newPdfDoc.copyPages(pdfDoc, pdfDoc.getPageIndices());
          pages.forEach(page => newPdfDoc.addPage(page));

          // Compress images and fonts
          const pdfBytes = await newPdfDoc.save({ useObjectStreams: false });

          return new Blob([pdfBytes], { type: 'application/pdf' });
        };

        pdfBlob = await compressPDF(pdfBlob);
        pdfFile = new File([pdfBlob], 'signed_contract_compressed.pdf', { type: 'application/pdf' });
        console.log(pdfFile)
      }
      console.log(pdfFile)
      this.selectedDocument = pdfFile;
      this.storePDFInS3(pdfBlob);

      // Reset styles and flags
      element.style.height = originalHeight;
      element.style.overflow = originalOverflow;
      document.head.removeChild(styleElement);
      this.isLoading = false;
      // element.style.display = 'none';

    } catch (error) {
      console.error('Error generating PDF:', error);
      this.isLoading = false;
      element.style.height = originalHeight;
      element.style.overflow = originalOverflow;
      // element.style.display = 'none';
    }
  }


  async storePDFInS3(pdfBlob) {

    // console.log("blobsize :: " + pdfBlob.size);
    // const chunkSize = 128 * 1024; // 512KB
    // const maxParallelUploads = 5;
    // const totalChunks = Math.ceil(pdfBlob.size / chunkSize);
    // const enumType = "START";
    // let currentChunk = 0;

    // console.log("totalChunks :: " + totalChunks);

    // const uploadAllChunks = async () => {
    //   const uploads: Promise<void>[] = [];
    //   const now = new Date();
    //   const currentDatetimeInMilliseconds = now.getTime();

    //   let filename = "PDF-" + this.profile.entity.id + "-" + currentDatetimeInMilliseconds + ".pdf";
    //   while (currentChunk < totalChunks) {
    //     let imageUploadChunkAPIUrl = UploadAttendancePictureChunk + this.profile.entity.id;
    //     const chunk = pdfBlob.slice(currentChunk * chunkSize, (currentChunk + 1) * chunkSize);
    //     const partFileName = `${filename}.part${currentChunk}`;
    //     imageUploadChunkAPIUrl = imageUploadChunkAPIUrl + `?filename=${partFileName}&chunkNumber=${currentChunk}&totalChunks=${totalChunks}`;

    //     uploads.push(this.uploadChunk(imageUploadChunkAPIUrl, `${filename}.part${currentChunk}`, chunk, currentChunk, totalChunks));
    //     currentChunk++;

    //     console.log("currentChunk :: " + currentChunk);

    //     if (uploads.length >= maxParallelUploads || currentChunk === totalChunks) {
    //       await Promise.all(uploads);
    //       console.log("All chunks uploaded 1 ...");
    //       uploads.length = 0; // Clear the array for the next batch
    //     }
    //   }
    // };

    // await uploadAllChunks();
    // console.log("All chunks uploaded...");

    // await this.callAnotherAPI(totalChunks, enumType);
    console.log("this.selectedDocument===", this.selectedDocument);
    if (this.selectedDocument) {
      this.isLoading = true;
      this.jobService.uploadPdf(this.selectedDocument).subscribe(res => {
        this.selectedPojectData.selectedProject.documentUrl = res.key;
        this.uploadSignedDocument();
        return;
      }, (err => {
        this.isLoading = false;
      }))
    }
  }

  // async uploadChunk(imageUploadAPIUrl: string, fileName: string, chunk: any, chunkNumber: number, totalChunks: number) {
  //   console.log("Uploading the chunk :: " + chunkNumber);
  //   const formData = new FormData();
  //   let filename = fileName;
  //   formData.append('image', chunk, filename);
  //   this.jobService.PostChunkMethod(imageUploadAPIUrl, formData, "", chunkNumber, totalChunks).subscribe(res => {
  //     console.log("_____________", res)
  //   });
  // }

  // callAnotherAPI(totalChunks, enumType) {
  //   let processImageChunkAPIUrl = ProcessAttendancePictureChunk + this.profile.entity.id;
  //   const now = new Date();
  //   const currentDatetimeInMilliseconds = now.getTime();
  //   let filename = "PDF-" + this.profile.entity.id + "-" + currentDatetimeInMilliseconds + ".pdf";
  //   processImageChunkAPIUrl = processImageChunkAPIUrl + `?filename=${filename}&totalChunks=${totalChunks}&enumType=${enumType}`;
  //   const finalFormData = new FormData();
  //   //finalFormData.append('image', blobData, filename);
  //   console.log("post chunk merge...");
  //   this.jobService.PostChunkWholeMethod(processImageChunkAPIUrl, finalFormData, totalChunks).subscribe(res => {
  //     console.log("++++++++++++++++++++++++", res)
  //   });
  // }

  async downloadSignedDoc() {
    let pdfStyles = `
    .contract-wrapper {
        padding: 24px;
        background: #fff;
        border-radius: var(--radius-xl, 12px);
    }

    .header {
        border-radius: var(--radius-xl, 12px);
        background: var(--Neutral-20, #F6F6F6);
        padding: 12px 16px;
    }

    .sub-header {
        padding: 12px 16px;
    }

    .f-wrap {
        flex-wrap: wrap !important;
    }

    .signature-section {
        width: 50%;
    }

    .inputt-wrap {
        border: none;
        border-bottom: 1px solid #000;
        outline: none;
    }

    .signature-img {
        max-width: 60%;
        max-height: 20vh;
    }

    .custom-signature-card {
        border-radius: var(--radius-xl, 12px);
        border: 1px dashed var(--Neutral-60, #1A1A1A);
        background: var(--base-w-white, #FFF);
        box-shadow: 0px 1px 2px 0px rgba(26, 26, 26, 0.04);
        display: inline-flex;
        height: 132px;
        padding: 16px 20px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 12px;
    }

    .d-flex {
        display: flex;
    }

    .secondary {
        color: #1A1A1A !important;
    }

    .sub-heading-mm {
        font-style: normal !important;
        font-size: 14px !important;
    }

    .sub-heading-sm {
      font-style: normal !important;
        font-size: 14px !important;
    }

    .justify-space-between {
        justify-content: space-between !important;
    }

    .text-center {
        text-align: center;
    }

     .outer-wrap {
        flex: 1;
        overflow: visible !important;
    }

    .inner-wrap {
        flex: 1;
        overflow-y: visible !important;
    }
         .w-70 {
      width : 100% !important;
    }

    .h-82{
    height : auto !important;
    }
    `;
    if (window.innerWidth <= 768) {
      pdfStyles = `
    .contract-wrapper {
        padding: 24px;
        background: #fff;
        border-radius: var(--radius-xl, 12px);
    }

    .header {
        border-radius: var(--radius-xl, 12px);
        background: var(--Neutral-20, #F6F6F6);
        padding: 12px 16px;
    }

    .sub-header {
        padding: 12px 11px;
    }

    .f-wrap {
        flex-wrap: wrap !important;
    }

    .signature-section {
        width: 50%;
    }

    .inputt-wrap {
        border: none;
        border-bottom: 1px solid #000;
        outline: none;
    }

    .signature-img {
        max-width: 60%;
        max-height: 20vh;
    }

    .custom-signature-card {
        border-radius: var(--radius-xl, 12px);
        border: 1px dashed var(--Neutral-60, #1A1A1A);
        background: var(--base-w-white, #FFF);
        box-shadow: 0px 1px 2px 0px rgba(26, 26, 26, 0.04);
        display: inline-flex;
        height: 132px;
        padding: 16px 20px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 12px;
    }

    .d-flex {
        display: flex;
    }

    .secondary {
        color: #1A1A1A !important;
    }

    .sub-heading-mm {
        font-style: normal !important;
        font-size: 12px !important;
    }

    .sub-heading-sm {
      font-style: normal !important;
        font-size: 12px !important;
    }

    .justify-space-between {
        justify-content: space-between !important;
    }

    .text-center {
        text-align: center;
    }

     .outer-wrap {
        flex: 1;
        overflow: visible !important;
    }

    .inner-wrap {
        flex: 1;
        overflow-y: visible !important;
    }

    .m-4 {
        margin: 0px !important;
    }

    .w-70 {
        grid-area: agreement-doc;
        //     display: none;
        width: 100% !important;
        padding: 0px !important;
    }

    .w-30 {
        width: 100% !important;
        grid-area: sign-contract;
        padding: 16px !important;
        background-color: transparent !important;
    }

    .h-82 {
        display: grid !important;
        grid-template-areas:
            "sign-contract"
            "agreement-doc" !important;
        height: auto !important;
    }

    .footer-card {
        bottom: 8% !important;
        margin: 0px !important;
    }
    `;
    }


    const element = this.content.nativeElement;
    element.style.display = 'block';

    const originalHeight = element.style.height;
    const originalOverflow = element.style.overflow;
    this.isDownloading = true;

    const styleElement = document.createElement('style');
    styleElement.type = 'text/css';
    styleElement.innerHTML = pdfStyles;
    document.head.appendChild(styleElement);

    // Function to resize inputs if necessary
    const resizeInputs = () => {
      const inputs = element.querySelectorAll('.inputt-wrap');
      inputs.forEach(input => {
        const valueLength = input.value.length;
        const newWidth = valueLength && (valueLength >= 20 && valueLength <= 40) ? (valueLength + 1) * 8 : 150;
        input.style.width = `${newWidth}px`;
        if (window.innerWidth <= 768) {
          input.style.lineHeight = '20px';
        }
        input.style.backgroundColor = 'transparent';
      });
    };

    // Load images function
    const loadImages = (): Promise<void[]> => {
      const images = Array.from(document.querySelectorAll('img.signature-img'));
      const imagePromises = images.map((img: HTMLImageElement) => {
        return new Promise<void>((resolve, reject) => {
          fetch(img.src, {
            method: 'GET',
            mode: 'no-cors'
          })
            .then(response => {
              console.log(response)
              resolve();
            })
            .catch(error => {
              console.error('There has been a problem with your fetch operation:', error);
              reject(new Error('Image failed to load'));
            });
        });
      });
      return Promise.all(imagePromises);
    };

    try {
      // Ensure all images and fonts are loaded
      await Promise.all([loadImages(), resizeInputs()]);
      await new Promise(resolve => setTimeout(resolve, 2000));

      // Use html2canvas to capture the entire content as a single canvas
      const canvas = await html2canvas(element, {
        scale: 2, // Adjust scale if needed
        useCORS: true,
        allowTaint: true, // Allow taint to render images from other domains
        scrollX: -window.scrollX,
        scrollY: -window.scrollY,
      });

      console.log(canvas.width, canvas.height)
      // canvas.height = canvas.height + 5000;
      // Calculate dimensions for jsPDF
      const pdfWidth = canvas.width * 0.264583; // Convert px to mm (1px = 0.264583mm)
      const pdfHeight = canvas.height * 0.264583; // Convert px to mm
      console.log(pdfWidth, pdfHeight)
      // Create jsPDF instance
      const pdf = new jsPDF('p', 'mm', [pdfWidth, pdfHeight], true);

      // Add the captured canvas as an image to jsPDF
      pdf.addImage(canvas, 'JPEG', 0, 0, pdfWidth, pdfHeight);

      // Save or download the PDF
      pdf.save('signed_contract.pdf');

      // Reset styles and flags
      element.style.height = originalHeight;
      element.style.overflow = originalOverflow;
      document.head.removeChild(styleElement);
      this.isDownloading = false;
      element.style.display = 'none';

    } catch (error) {
      console.error('Error generating PDF:', error);
      this.isDownloading = false;
      element.style.height = originalHeight;
      element.style.overflow = originalOverflow;
      element.style.display = 'none';
    }
  }

  filledSigedContractDetails(event) {
    this.contractMetaData = event;
  }

  goToBackPage() {
    localStorage.removeItem("selectedPojectData");
    this.location.back();
    // this.router.navigate(['/job'], { relativeTo: this.route });
  }

  goToSuccessPage() {
    localStorage.removeItem("selectedPojectData");
    this.router.navigate(['/job/success-signed-doc', this.selectedPojectData.id], { relativeTo: this.route });
  }
}